"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPanelRender = void 0;
var React = __importStar(require("react"));
var common_1 = require("@scuf/common");
var localization_1 = require("@scuf/localization");
var Item_1 = __importDefault(require("./Item/Item"));
var FilterPanelRender = /** @class */ (function (_super) {
    __extends(FilterPanelRender, _super);
    function FilterPanelRender(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleShow = function () {
            if (_this.state.show) {
                _this.setState({ show: false, showUp: false });
            }
            else {
                _this.setState({ show: true }, function () {
                    var rect = _this.menuRef.getBoundingClientRect();
                    var direction = rect.bottom >= (window.innerHeight || document.documentElement.clientHeight);
                    _this.setState({ showUp: direction });
                });
            }
        };
        _this.genClasses = function () {
            var _a = _this.state, show = _a.show, showUp = _a.showUp;
            var className = _this.props.className;
            var classes = 'filter-panel';
            if (show) {
                classes += ' show';
            }
            if (className) {
                classes += ' ' + className;
            }
            if (showUp) {
                classes += ' up';
            }
            else {
                classes += ' down';
            }
            return classes;
        };
        _this.captureClick = function (e) {
            var dom = e.target;
            if (!_this.props.manualClose) {
                if (!_this.menuRef.contains(dom) && !_this.buttonRef.contains(dom)) {
                    _this.setState({ show: false });
                }
            }
        };
        _this.state = { show: false, showUp: true };
        return _this;
    }
    FilterPanelRender.prototype.componentWillMount = function () {
        document.addEventListener('click', this.captureClick);
    };
    FilterPanelRender.prototype.componentWillUnmount = function () {
        document.removeEventListener('click', this.captureClick);
    };
    FilterPanelRender.prototype.render = function () {
        var _this = this;
        var _a = this.props, onReset = _a.onReset, children = _a.children, t = _a.t, className = _a.className, count = _a.count, rest = __rest(_a, ["onReset", "children", "t", "className", "count"]);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "header-bar-item filter-panel-icon", onClick: this.toggleShow, ref: function (ref) { return (_this.buttonRef = ref); } }, common_1.genIcon('filter', {
                root: 'building',
                size: 'large',
                className: count && 'badged-filter'
            }, {
                content: count,
                color: 'blue'
            })),
            React.createElement("div", __assign({ className: this.genClasses(), ref: function (ref) { return (_this.menuRef = ref); } }, rest),
                onReset && (React.createElement(Item_1.default, { className: "reset-all" },
                    React.createElement("span", { onClick: onReset, className: "reset" }, t('Reset all filters')))),
                children)));
    };
    return FilterPanelRender;
}(React.Component));
exports.FilterPanelRender = FilterPanelRender;
exports.default = localization_1.InjectLocalization(FilterPanelRender);
//# sourceMappingURL=FilterPanelRender.js.map